import * as React from 'react';

import VttError from '../api/vttError';

export const ErrorPage: React.StatelessComponent<VttError> = error => (
  <main className="contentpage">
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-sm-12">
          <span className="big-text">Sisältö ei löytynyt</span>
          <p className="help-text">Ehkä linkki ei toimi?<span className="hidden">{error.message}</span></p>          
        </div>
      </div>
    </div>
  </main>
);



// WEBPACK FOOTER //
// ./src/components/errorPage.tsx